import { useCallback } from 'react';
import { useUrls } from '~/contexts/url.context';

export function useNavegacaoModuloDinamico({
  history,
  visao,
  urlVisaoAnalitica,
  urlVisaoAgrupamento,
  filtro,
  setFiltro,
  setColunaFiltroRedirecionaVisao,
  setValorFiltroRedirecionaVisao,
  setTipoValorFiltroRedirecionaVisao,
  setListaColunaOrdem,
  normalizarListaColunaOrdem,
  setExercicioSelecionado,
  setPeriocidadeSelecionada,
  setPeriodoSelecionado,
  setQuantidadeRegistros,
}) {
  const { obterUrlPaginaAnterior } = useUrls();

  const voltarPaginaAnterior = useCallback(() => {
    const { urlBase, queryParam } = obterUrlPaginaAnterior();

    if (urlBase) {
      history.push({
        pathname: urlBase,
        search: queryParam || '',
      });
    } else {
      // Fallback: volta para home
      history.push(`/`);
    }
  }, [history, obterUrlPaginaAnterior]);

  const carregarPagina = useCallback(() => {
    if (visao !== urlVisaoAnalitica && visao !== urlVisaoAgrupamento) {
      setColunaFiltroRedirecionaVisao(null);
      setValorFiltroRedirecionaVisao(null);
      setTipoValorFiltroRedirecionaVisao(null);
      if (filtro?.length) {
        setFiltro([]);
      }
    } else if (history.location.state) {
      const {
        chaveSelecionada,
        colunaSelecionada,
        tipoValorColunaSelecionada,
        exercicio,
        periodicidade,
        periodo,
        tipoOrdem,
        isFromAgrupamento,
        // variaveis com o mesmo nome ja existem no escopo acima
        quantidadeRegistros: quantidadeRegistrosHistory,
        colunaFiltroRedirecionaVisao: colunaFiltroRedirecionaVisaoHistory,
        valorFiltroRedirecionaVisao: valorFiltroRedirecionaVisaoHistory,
        tipoValorFiltroRedirecionaVisao: tipoValorFiltroRedirecionaVisaoHistory,
        colunaOrdem: colunaOrdemHistory,
        filtro: filtroHistory,
      } = history.location.state;

      if (colunaFiltroRedirecionaVisaoHistory) {
        setColunaFiltroRedirecionaVisao(colunaFiltroRedirecionaVisaoHistory);
      } else {
        setColunaFiltroRedirecionaVisao(colunaSelecionada);
      }

      if (valorFiltroRedirecionaVisaoHistory) {
        setValorFiltroRedirecionaVisao(valorFiltroRedirecionaVisaoHistory);
      } else if (isFromAgrupamento) {
        setValorFiltroRedirecionaVisao(chaveSelecionada);
      }

      if (tipoValorFiltroRedirecionaVisaoHistory) {
        setTipoValorFiltroRedirecionaVisao(
          tipoValorFiltroRedirecionaVisaoHistory
        );
      } else {
        setTipoValorFiltroRedirecionaVisao(tipoValorColunaSelecionada);
      }

      setFiltro(filtroHistory);

      if (colunaOrdemHistory && tipoOrdem) {
        setListaColunaOrdem(
          normalizarListaColunaOrdem([
            {
              ColunaOrdem: colunaOrdemHistory,
              TipoOrdem: tipoOrdem,
              Ordem: 1,
            },
          ])
        );
      }
      setExercicioSelecionado(exercicio);

      setPeriocidadeSelecionada(periodicidade);
      setPeriodoSelecionado(periodo);
      setQuantidadeRegistros(quantidadeRegistrosHistory || '10');

      // eslint-disable-next-line no-param-reassign
      history.location.state = null;
    }
  }, [
    filtro,
    history,
    normalizarListaColunaOrdem,
    setColunaFiltroRedirecionaVisao,
    setExercicioSelecionado,
    setFiltro,
    setListaColunaOrdem,
    setPeriocidadeSelecionada,
    setPeriodoSelecionado,
    setQuantidadeRegistros,
    setTipoValorFiltroRedirecionaVisao,
    setValorFiltroRedirecionaVisao,
    urlVisaoAgrupamento,
    urlVisaoAnalitica,
    visao,
  ]);

  return {
    carregarPagina,
    voltarPaginaAnterior,
  };
}
